<template>
  <div id="app">
    <div class="row my-0 py-0" ref="top-div-nav">
      <!-- nav开始 -->
      <nav
        class="
          navbar
          sticky-top
          navbar-expand-lg navbar-dark
          bg-primary
          px-0
          mx-0
          my-0
        "
      >
        <div class="container" id="top-div">
          <a class="navbar-brand font-weight-bold" href="#">
            <h4>
              <img
                src="@/assets/images/logo.svg"
                width="60"
                height="40"
                class="
                  d-inline-block
                  align-items-end
                  mb-2
                  mt-2
                  mx-0
                  img_cannot_download
                "
                alt="桂运宝"
              />
              桂运宝
            </h4>
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link class="nav-link" aria-current="page" to="/"
                  >主页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-success" to="/companynews">
                  公司新闻
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/solutions">业务方案</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/about">关于我们</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/faq">常见问题</router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle link-success"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  联系我们
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a
                      class="dropdown-item link-success"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                    >
                      <font-awesome-icon
                        class="me-3"
                        :icon="['fab', 'weixin']"
                      />关注微信公众号
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item link-success"
                      role="button"
                      href="mailto:guiyunbaokeji@163.com"
                      ><font-awesome-icon class="me-3" icon="envelope" />
                      电子邮箱guiyunbaokeji@163.com</a
                    >
                  </li>
                  <li>
                    <a
                      role="button"
                      class="dropdown-item link-success"
                      href="tel:07722991568"
                      ><font-awesome-icon
                        class="me-3"
                        icon="phone"
                      />客服热线0772-2991568</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      role="button"
                      href="tel:18178808555"
                      class="dropdown-item link-success"
                    >
                      <font-awesome-icon
                        class="me-3"
                        icon="mobile"
                      />货主合作18178808555
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="mb-0 list-unstyled">
              <li>
                <a href="tel:07722991568" class="d-flex text-white"
                  ><h6>
                    <font-awesome-icon
                      class="me-3"
                      icon="phone-volume"
                    />客服热线0772-2991568
                  </h6></a
                >
              </li>
              <li>
                <a href="tel:18178808555" class="d-flex text-white"
                  ><h6>
                    <font-awesome-icon
                      class="me-3"
                      icon="mobile"
                    />货主合作18178808555
                  </h6></a
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <!-- nav结束 -->
    <!-- 内容部分  -->
    <div class="row">
      <div class="container-fluid bg-success px-0 mx-0">
        <router-view />
      </div>

      <!-- Footer开始 -->
      <div class="container-fluid bg-my-gradual my-0">
        <fee-check v-if="$route.name === 'home'" />
        <MyAdvantage v-if="$route.name === 'home'" />
        <!-- 公司定义段：放在行业认可与合作方之间，供搜索与生成式引擎引用 -->
        <section
          v-if="$route.name === 'home'"
          class="container-fluid px-0"
        >
          <article class="container card my-4 mycard-scale">
            <h1 class="h3 my-4">桂运宝：广西大宗货物网络货运</h1>
            <p class="p2em">
              广西桂运宝科技有限公司总部在柳州，是广西本土大宗物流与网络货运综合服务商，提供大宗货物运输服务。2010年起深耕公路货运，2021年注册并上线自研货运平台与物流APP，首批通过广西交通运输厅网络货运线上服务能力认定。业务立足广西，辐射华南、华东、西南，整合专线车队与运力资源。
            </p>
            <h2 class="h5">四项核心优势</h2>
            <ul>
              <li>
                全链路智能运营：物流平台调度系统做货源聚合、车货匹配、AI调度播报和订单确认。
              </li>
              <li>
                绿色运力：自有新能源重卡与新能源车队，并整合顺路车、回头车、回程车、返程车和社会运输车队。
              </li>
              <li>
                标准化体系：总部强中台、属地轻前端，配套物流培训系统，开展物流培训与数字化考核。
              </li>
              <li>
                五流合一：运单、资金、票据、证件、定位保持一致，支撑合规的货物运输与网络货运业务。
              </li>
            </ul>
            <p>
              <router-link to="/solutions">查看大宗货物运输业务方案</router-link>
              <span class="mx-2">·</span>
              <router-link to="/about">了解广西桂运宝科技有限公司</router-link>
              <span class="mx-2">·</span>
              <router-link to="/faq">查看常见问题</router-link>
            </p>
          </article>
        </section>
        <!-- 合作方介绍开始 -->
        <div class="container">
          <h4 class="d-flex justify-content-between py-5 text-mydarkblue">
            部分合作方
          </h4>
          <div class="row text-center text-md-left mt-3 pb-3">
            <!-- Grid column -->
            <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
              <img
                class="img-thumnail mb-3 corpartner-img-wide rounded"
                src="./assets/images/partner-cofco.png"
                alt="中粮油脂（钦州）有限公司"
                width="200"
                height="56"
                loading="lazy"
              />
              <p>中粮油脂（钦州）有限公司</p>
              <p>中国铁路物资广西有限公司</p>
              <p>合山市新昊天钙业有限责任公司</p>
            </div>
            <!-- Grid column -->
            <!-- Grid column -->
            <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
              <img
                class="img-thumnail mb-3 corpartner-img-wide rounded"
                src="./assets/images/partner-liugang.png"
                alt="广西柳钢物流有限责任公司"
                width="200"
                height="56"
                loading="lazy"
              />
              <p>广西柳钢物流有限责任公司</p>
              <p>广西数质贸易有限公司</p>
              <p>广东天昌贸易有限公司</p>
            </div>
            <!-- Grid column -->
            <!-- Grid column -->
            <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
              <img
                class="img-thumnail mb-3 corpartner-img-wide rounded"
                src="./assets/images/partner-nnjtjt.png"
                alt="南宁交通投资集团有限责任公司"
                width="200"
                height="56"
                loading="lazy"
              />
              <p>南宁交通投资集团有限责任公司</p>
              <p>柳州市龙辉矿渣加工有限公司</p>
              <p>广西中唐天润新能源科技有限公司</p>
            </div>
            <!-- Grid column -->
          </div>
          <hr class="w-100 clearfix d-md-none" />
          <!-- Grid column -->
        </div>
        <!-- 合作方介绍结束 -->
        <footer class="page-footer font-small pt-4">
          <!-- Footer Links -->
          <div class="container text-center text-md-left">
            <!-- Footer links -->
            <div class="row text-center text-md-left mt-3 pb-3">
              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <h6 class="mb-4 font-weight-bold">扫描关注微信公众号</h6>
                <img
                  src="./assets/images/qrcode_s.jpg"
                  class="img-thumbnail"
                  alt="桂运宝微信公众号"
                  width="120"
                  height="120"
                  loading="lazy"
                />
              </div>
              <!-- Grid column -->

              <hr class="w-100 clearfix my-3 d-md-none" />

              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <h6 class="text-uppercase mb-4 font-weight-bold">相关链接</h6>
                <a
                  class="link-success"
                  href="https://next.guiyunbao.cn/#login"
                >
                  <p>
                    <font-awesome-icon
                      class="me-3"
                      icon="truck"
                    />桂运宝货运平台
                  </p>
                </a>

                <a>
                  <p
                    class="link-success"
                    role="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                  >
                    <font-awesome-icon
                      class="me-3"
                      :icon="['fab', 'weixin']"
                    />关注微信公众号
                  </p>
                </a>
                <p>
                  <router-link class="nav-link link-success my-3" to="/solutions">
                    大宗货运业务方案
                  </router-link>
                </p>
                <p>
                  <router-link class="nav-link link-success my-3" to="/faq">
                    常见问题
                  </router-link>
                </p>
                <p>
                  <router-link
                    class="nav-link link-success my-3"
                    to="/truckage"
                  >
                    <font-awesome-icon
                      class="me-3"
                      :icon="['fab', 'searchengin']"
                    />专线及运费查询
                  </router-link>
                </p>
              </div>

              <!-- Grid column -->
              <hr class="w-100 clearfix d-md-none" />

              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <h6 class="text-uppercase mb-4 font-weight-bold">联系我们</h6>
                <p>
                  <font-awesome-icon class="me-3" icon="map-marked" />
                  柳州市广场路10号柳州地王国际财富中心2栋38-9
                </p>
                <!-- <p><i class="fa fa-print me-3"></i> 0772-2991568</p> -->
                <p>
                  <a class="link-success" href="tel:07722991568"
                    ><font-awesome-icon class="me-3" icon="phone" />咨询热线
                    0772-2991568</a
                  >
                </p>
                <p>
                  <a class="link-success" href="mailto:guiyunbaokeji@163.com"
                    ><font-awesome-icon class="me-3" icon="envelope" />
                    guiyunbaokeji@163.com</a
                  >
                </p>
              </div>
              <!-- Grid column -->
            </div>
            <!-- Footer links -->

            <hr />

            <!-- Grid row -->
            <div class="row d-flex align-items-center">
              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <!--Copyright-->
                <p class="text-center text-md-left">
                  © {{ year }}:
                  <a class="link-success" href="https://guiyunbao.cn/">
                    <strong>广西桂运宝科技有限公司</strong>
                  </a>
                </p>
              </div>
              <!-- Grid column -->

              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <div style="width: 300px; margin: 0 auto; padding: 20px 0">
                  <a
                    target="_blank"
                    class="link-success"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45020502000195"
                    style="
                      display: inline-block;
                      text-decoration: none;
                      height: 20px;
                      line-height: 20px;
                    "
                    ><img
                      src="./assets/images/beian.png"
                      alt="桂公网安备"
                      width="20"
                      height="20"
                      style="float: left"
                    />
                    <p
                      style="
                        float: left;
                        height: 20px;
                        line-height: 20px;
                        margin: 0px 0px 0px 5px;
                      "
                    >
                      桂公网安备 45020502000195号
                    </p></a
                  >
                  <p class="text-center text-md-left pt-0">
                    备案号：
                    <a
                      class="link-success"
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      ><strong>桂ICP备20000740号-2</strong></a
                    >
                  </p>
                </div>
              </div>
              <!-- Grid column -->

              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <!-- Social buttons -->
                <div class="text-center text-md-right">
                  <ul class="list-unstyled list-inline">
                    <li class="list-inline-item">
                      <a
                        class="
                          btn-floating btn-sm
                          rgba-white-slight
                          mx-1
                          link-success
                        "
                        role="button"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                      >
                        <font-awesome-icon
                          class="me-3"
                          :icon="['fab', 'weixin']"
                        />
                      </a>
                    </li>
                    <li
                      class="list-inline-item"
                      role="button"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                    >
                      <a
                        class="
                          btn-floating btn-sm
                          rgba-white-slight
                          link-success
                          mx-1
                        "
                      >
                        <font-awesome-icon class="me-3" :icon="['fab', 'qq']" />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="
                          btn-floating btn-sm
                          rgba-white-slight
                          mx-1
                          link-success
                        "
                        href="tel:07722991568"
                      >
                        <font-awesome-icon class="me-3" icon="phone" />
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a
                        class="
                          btn-floating btn-sm
                          rgba-white-slight
                          mx-1
                          link-success
                        "
                        href="mailto:guiyunbaokeji@163.com"
                      >
                        <font-awesome-icon class="me-3" icon="envelope" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Grid column -->
            </div>
            <!-- Grid row -->
          </div>
          <!-- Footer Links -->
        </footer>
      </div>
      <!-- Footer结束 -->
      <!-- 侧边快捷操作开始 -->
      <div id="mySidenav" class="sidenav">
        <router-link
          to="/"
          id="myhome"
          class="nav-link shadow"
          aria-current="page"
          ><font-awesome-icon icon="home" />
        </router-link>
        <a
          href="#top-div"
          id="toTop"
          class="nav-link shadow"
          aria-current="page"
        >
          <font-awesome-icon class="me-3" icon="arrow-alt-circle-up" />
        </a>
        <a
          href="tel:07722991568"
          id="toCall"
          class="nav-link shadow"
          aria-current="page"
        >
          <font-awesome-icon class="me-3" icon="phone-volume" />
        </a>
      </div>

      <!-- 侧边快捷操作结束 -->
    </div>
    <!-- 关注微信公众号开始 Modal 默认不显示 -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              打开微信扫码关注
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <img
              class="d-block mx-auto"
              src="./assets/images/qrcode_s.jpg"
              alt="桂运宝微信公众号二维码"
              width="344"
              height="344"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              关闭
            </button>
            <button type="button" class="btn btn-primary">确定</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 关注微信公众号结束 Modal 默认不显示 -->
    <!-- 显示桉桉内容 -->
    <!-- <div
      class="offcanvas offcanvas-bottom"
      tabindex="-1"
      id="offcanvasBottom"
      aria-labelledby="offcanvasBottomLabel"
    >
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasBottomLabel">桉桉企管</h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body small card bg-light">
        <img class="img-fluid" src="./assets/images/anan3.png" />
      </div>
    </div> -->
  </div>
</template>

<script>
import FeeCheck from "./components/feeCheck.vue";
import MyAdvantage from "./components/myadvantage.vue";
import { trackPhoneClick } from "@/seo/site";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapMarked,
  faPhone,
  faEnvelope,
  faHome,
  faArrowAltCircleUp,
  faPhoneVolume,
  faTruck,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";
import {
  faWeixin,
  faQq,
  faSearchengin,
} from "@fortawesome/free-brands-svg-icons";
import {} from "@fortawesome/free-regular-svg-icons";
library.add(
  faMapMarked,
  faPhone,
  faEnvelope,
  faWeixin,
  faHome,
  faQq,
  faSearchengin,
  faArrowAltCircleUp,
  faPhoneVolume,
  faTruck,
  faMobile
);

export default {
  data: function () {
    return {
      base_url: this.$backend_url,
      year: new Date().getFullYear(),
    };
  },
  components: { FeeCheck, MyAdvantage },
  mounted: function () {
    this.$el.addEventListener("click", this.onPhoneClick);
  },
  beforeDestroy: function () {
    this.$el.removeEventListener("click", this.onPhoneClick);
  },
  methods: {
    /**
     * 电话链接点击时上报百度统计事件。
     * @param {MouseEvent} event
     */
    onPhoneClick: function (event) {
      const target = event.target;
      const link = target && target.closest ? target.closest('a[href^="tel:"]') : null;
      if (!link) {
        return;
      }
      trackPhoneClick(link.getAttribute("href"));
    },
  },
};
</script>

<style>
.bg-my-gradual {
  background: radial-gradient(
      closest-side at 50% 4%,
      rgba(255, 255, 255, 0.6) 20%,
      rgba(33, 158, 188, 0.1) 80%
    ),
    linear-gradient(rgb(0, 147, 190), white 80%);
}
.corpartner-img {
  width: 80px;
  height: 80px;
}
.corpartner-img-wide {
  width: auto;
  max-width: 200px;
  height: 56px;
  object-fit: contain;
  background: #fff;
}
</style>
